import { ApolloLink } from "@apollo/client";
import { map } from "rxjs";

// Its own module so the server client (api/serverClient.ts) can use it too.

/*
 * Drops `ErrorNotImplemented` from a result before the client sees it, so the
 * operation still resolves with whatever data the server returned.
 *
 * Apollo Client 4 links are rxjs observables, so this maps with `pipe`
 * rather than the zen-observable `.map` it used. It sits above the error
 * link: `ErrorLink` only observes, and the client raises
 * `CombinedGraphQLErrors` from `result.errors` further up, so stripping here
 * keeps the error link's view of the response complete while still
 * swallowing the error.
 */
export const suppressErrors = new ApolloLink((operation, forward) =>
	forward(operation).pipe(
		map((result) => {
			if (!result.errors?.length) {
				return result;
			}

			const errors = result.errors.filter(
				(error) => error.message !== "ErrorNotImplemented",
			);

			if (errors.length === result.errors.length) {
				return result;
			}

			if (errors.length > 0) {
				return { ...result, errors };
			}

			// An empty `errors` array still reads as a failure, so drop the key.
			const withoutErrors = { ...result };
			delete withoutErrors.errors;
			return withoutErrors;
		}),
	),
);
